module.exports = __webpack_public_path__ + "static/media/tic-tac-toe-name.4ffaa199.gif";